/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bots: NonNullable<unknown> }} Features_Import_BodyInputs */



/**
* | output |
* | --- |
* | "Bring levels over from {bots}, reviewed before they count." |
*
* @param {Features_Import_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const features_import_body = /** @type {((inputs: Features_Import_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Import_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Перенесите уровни из ${i?.bots} — с проверкой до того, как они начнут действовать.`)
	return /** @type {LocalizedString} */ (`Bring levels over from ${i?.bots}, reviewed before they count.`)
});